/**
 * Business function. Treats entries from API.
 * @param {object} response The response of the API
 * @returns {object} The response treated.
 */
const treatsProperties = (response) =>
  response.data.items &&
  response.data.items.map((property) => {
    return {
      ...property,
      nbEntries: 0,
      nbActions: 0,
      nbActionplans: 0,
      act_list: property.act_list ? property.act_list.split(',') : [],
      acp_list: property.acp_list ? property.acp_list.split(',') : [],
    };
  });

export default treatsProperties;
